import { useState } from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { CreateRateDrawer } from './CreateRateDrawer';

export const CreateRateButton = ({ agreementId, planId, onRateCreated, ...props }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleClick = () => {
    setDrawerOpen(true);
  };

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const handleSuccess = () => {
    setDrawerOpen(false);
    onRateCreated?.();
  };

  return (
    <>
      <Button type='primary' icon={<PlusOutlined />} onClick={handleClick} {...props}>
        Crear tasa
      </Button>
      <CreateRateDrawer
        open={drawerOpen}
        onClose={handleClose}
        agreementId={agreementId}
        planId={planId}
        rate={null}
        onSuccess={handleSuccess}
      />
    </>
  );
};
